import React, { Suspense, lazy } from 'react';
import { getStripePromise } from '../../services/paymentMethodService';

const Elements = lazy(async () => {
  const { Elements } = await import('@stripe/react-stripe-js');
  return { default: Elements };
});

interface LazyStripeProviderProps {
  children: React.ReactNode;
}

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 24 }}>
    <span className="muted">Loading payment form...</span>
  </div>
);

export const LazyStripeProvider: React.FC<LazyStripeProviderProps> = ({ children }) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Elements stripe={getStripePromise()}>
        {children}
      </Elements>
    </Suspense>
  );
};

export default LazyStripeProvider;
